/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useConfig,
  useTheme,
  useUrlParams,
  useLocationUrlReplace,
  useDateUrlReplace,
  useLocationSelector,
  useDateSelector,
  useUtils
} from 'app/hooks';
import { Container, MoviesDatesFilter, NoContent, Carousel, ImageWithLoader } from 'app/components';
import FavoriteBtn from '../FavoriteBtn';
import { SectionCinemas, CinemasListItem } from './styles';

const propTypes = {
  getCinemasWithMovies: PropTypes.func.isRequired,
  setCinemasWithMovies: PropTypes.func.isRequired,
  getDates: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,

  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  cinemas: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  savedLocation: PropTypes.string.isRequired,

  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    replace: PropTypes.func.isRequired
  }).isRequired,
  setStoreDate: PropTypes.func.isRequired,
};

const carouselPropsConfig = (desktop, tablet) => ({
  slidesToSlide: 3,
  responsive: {
    desktop: {
      breakpoint: {
        max: 30000,
        min: desktop
      },
      items: 6
    },
    tablet: {
      breakpoint: {
        max: desktop,
        min: tablet
      },
      items: 4
    },
    mobile: {
      breakpoint: {
        max: tablet,
        min: 0
      },
      items: 3
    }
  }
});

const AllCinemas = ({
  getCinemasWithMovies,
  setCinemasWithMovies,
  getDates,
  setDates,

  dates,
  cinemas,
  locations,
  isLoggedIn,
  savedLocation,
  history,
  setStoreDate
}) => {
  const [t] = useTranslation();
  const { routes } = useConfig();
  const theme = useTheme();
  const { location, date } = useUrlParams('location', 'date');
  const urlSearchParams = new URLSearchParams(history.location.search);
  const carouselProps = useMemo(
    () =>
      carouselPropsConfig(
        parseInt(theme.breakPoints.md.width, 10),
        parseInt(theme.breakPoints.sm.width, 10)
      ),
    [theme]
  );

  const { onLocationSelected } = useLocationUrlReplace();
  const { isDateValid, isDateExist, onDateSelected } = useDateUrlReplace(dates);
  const { redLabelLocation, onSelectLocation } = useLocationSelector(
    location,
    savedLocation,
    onLocationSelected
  );
  const { redLabelDate, onSelectDate } = useDateSelector(date, onDateSelected);
  const { getFallbackDate } = useUtils();
  const [formatedCinemas, setFormatedCinemas] = useState(cinemas);

  useEffect(
    () => () => {
      setCinemasWithMovies(null);
      setDates(null);

      localStorage.removeItem("searchMovieId");
      localStorage.removeItem("eventId");
      sessionStorage.removeItem("seletEventMovieId");
      localStorage.removeItem("selectMovieId");
    },
    []
  );

  useEffect(() => {
    if(process.env.REACT_APP_COUNTRY === "svn"){
      document.title = "Cineplexx | Kina"
    }

    return () => {
      document.title = "Cineplexx"
    };

  }, [])


  useEffect(() => {
    if (location) {
      getDates();
    }
  }, [location]);

  useEffect(() => {
    if (date && location && date !== "all" && ((isDateValid && !isDateExist) || (isDateValid && isDateExist))) {
      getCinemasWithMovies(date);
    }

    if (date === "all") {
      const fallBackDateValue = getFallbackDate([]);

      urlSearchParams.set('date', fallBackDateValue);
      setStoreDate(fallBackDateValue);
      history.replace({
        search: `?${urlSearchParams.toString()}`
      });
      getCinemasWithMovies(fallBackDateValue)
    }
  }, [date, location]);

  useEffect(() => {
    // let fallBackDateValue = getFallbackDate(dates);
    urlSearchParams.set('date', date);

    history.replace({
      search: `?${urlSearchParams.toString()}`
    });
  }, [date])

  useEffect(() => {
    const prioritizedCinema = "Cineplexx Ljubljana Rudnik";

    const sortedCinemas = cinemas.sort((a, b) => {
      if (a.cinema.name === prioritizedCinema) return -1;
      if (b.cinema.name === prioritizedCinema) return 1;

    return 0;
    });

    if(process.env.REACT_APP_COUNTRY === 'svn'){
      setFormatedCinemas(sortedCinemas);
    }
  }, [cinemas])

  return (
    <SectionCinemas>
      <div className='fixed-cinema-date-location'>
        <Container>
          <MoviesDatesFilter
            locations={locations}
            selectedLocation={location || savedLocation}
            onSelectLocation={onSelectLocation}
            redLabelLocation={redLabelLocation}
            dates={dates.length ? dates : date === 'all' ? [] : [date]}
            selectedDate={date}
            onSelectDate={onSelectDate}
            redLabelDate={redLabelDate}
          />
        </Container>
      </div>
      <div className='cinema-list'>
        <Container>
          {formatedCinemas.length ? (
            <ul className="l-cinemas">
              {formatedCinemas.map(({ cinema, movies }) => (
                <CinemasListItem key={cinema.name} as="li" isLoggedIn={isLoggedIn}>
                  <p className="l-cinemas__link-wrapper">
                    {isLoggedIn && (
                      <FavoriteBtn
                        id={cinema.id}
                        loyaltyCode={cinema.loyaltyCode}
                        favorite={cinema.favorite}
                      />
                    )}

                    <NavLink
                      to={{
                        pathname: generatePath(routes.cinemaDetails.pattern, {
                          // id: cinema.name.replaceAll(' ', '-')
                          id: cinema.cinemaUrlName
                        }),
                        search: `?date=${date}`,
                        state: { cinemaId: cinema?.id }
                      }}
                      className="l-cinemas__link"
                    >
                      {cinema.name}
                    </NavLink>
                  </p>

                  <address className="l-cinemas__address">{cinema.address1}</address>

                  {movies && movies.length ? (
                    <Carousel {...carouselProps}>
                      {movies.map(({ posterImage, id, titlecalculated }) => (
                        <NavLink
                          key={id}
                          className="l-cinemas__movie-link"
                          to={{
                            pathname: generatePath(routes.movieDetails.pattern, {
                              // id: item?.shortURL ? item?.shortURL : item?.titleCalculated?.replaceAll(' ', '-')
                              id: titlecalculated?.replaceAll(' ', '-')
                            }),
                            search: `?date=${date}&location=${location === "all"}`,
                            state: { movieId: id, cinemaId: cinema?.id, selectCinema: true }
                          }}
                          onClick={() => sessionStorage.setItem('cinemaId', cinema?.id)}
                        >
                          <ImageWithLoader imgSrc={posterImage} imgTitle={titlecalculated} />
                        </NavLink>
                      ))}
                    </Carousel>
                  ) : (
                    <p className="l-cinemas__no-movies">{t('movies.no_for_date')}</p>
                  )}
                </CinemasListItem>
              ))}
            </ul>
          ) : (
            <NoContent svgId="no-cinema" text={t('cinemas.no_cinemas')} />
          )}
        </Container>
      </div>
    </SectionCinemas>
  );
};

AllCinemas.propTypes = propTypes;
export default AllCinemas;
